<template>
    <div>
        <app-sub-title text="Recomendaciones de seguridad" />
        <b-button variant="primary" @click="startSave" class="btn-block-xs-only"
            ><i class="fa fa-plus"></i> Crear recomendación de
            seguridad</b-button
        >
        <app-safety-recommendations-filters
            @filter="onFilter"
            :authors="authors"
            :access-points="accessPoints"
        />
        <app-table-safety-recommendations
            :data="data"
            @change-page="changePage"
            @update-recommendation="startUpdate"
            @remove-recommendation="startRemove"
            @upload-photos="startUploadPhotos"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->
        <app-pop-up
            title="Formulario recomendación de seguridad"
            id="safety-recommendation-form"
            :onClose="cleanForm"
        >
            <div class="body" slot="body">
                <app-safety-recommendation-form
                    :my-recommendation="selectRecommendation"
                    :onSave="onSave"
                    :access-points="accessPoints"
                    :is-supervision="isSupervision"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('safety-recommendation-form.save')"
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="safety-recommendation-remove">
            <div slot="body">
                <h2>
                    ¿Esta seguro que desea eliminar esta recomendación de
                    seguridad?
                </h2>
            </div>
            <div class="buttons" slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="deleteRecommendation(selectRecommendation)"
                >
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar
                    Eliminación
                </button>
            </div>
        </app-pop-up>

        <app-pop-up title="Agregar fotos" id="upload-photos-recommendation">
            <div slot="body">
                <b-card tag="article" style="max-width: 100%;" class="mb-2">
                    <div class="card-text">
                        <app-upload-or-take-photo
                            id="upload-safety-recommendation-photos"
                            title="Fotos de recomendación de seguridad"
                            v-model="files"
                        />
                        <div v-if="files">
                            <button
                                class="btn btn-sm btn-danger pull-right"
                                @click="cancelFilesSelected"
                            >
                                <i class="fa fa-trash-o" aria-hidden="true"></i>
                                Cancelar archivos seleccionados
                            </button>
                        </div>
                    </div>
                </b-card>
            </div>
            <div class="buttons" slot="buttons">
                <b-button
                    variant="primary"
                    class="btn-block-xs-only"
                    :disabled="!files ? !files : inProgress"
                    @click="savePhotos(selectRecommendation)"
                    ><i class="fa fa-floppy-o"></i> Guardar fotos</b-button
                >
            </div>
        </app-pop-up>

        <!-- fin de pop ups -->
    </div>
</template>

<script>
import TableSafetyRecommendations from "./TableSafetyRecommendations/TableSafetyRecommendations.vue";
import SafetyRecommendationsFilters from "./SafetyRecommendationsFilters/SafetyRecommendationsFilters";
import SafetyRecommendationForm from "./SafetyRecommendationForm/SafetyRecommendationForm.vue";
import structuresRepository from "../../../repositories/structures.repository.js";
import safetyRecommendationsRepository from "../../../repositories/safetyRecommendations.repository";
import UploadOrTakePhoto from "../../UI/Controls/Photos/UploadOrTakePhoto.vue";
export default {
    components: {
        appTableSafetyRecommendations: TableSafetyRecommendations,
        appSafetyRecommendationsFilters: SafetyRecommendationsFilters,
        appSafetyRecommendationForm: SafetyRecommendationForm,
        appUploadOrTakePhoto: UploadOrTakePhoto
    },
    props: {
        theClient: {
            type: Object,
            default: null
        },
        isSupervision: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            clientRequired: false,
            data: {},
            accessPoints: [],
            authors: [],
            selectRecommendation: "",
            sort: {
                sortBy: "created_at",
                sortDir: "desc"
            },
            theFilters: {},
            page: 1,
            files: ""
        };
    },

    methods: {
        loadSafetyRecommendations() {
            const srr = { ...safetyRecommendationsRepository };
            if (!this.clientRequired) {
                const filters = {
                    ...this.theFilters,
                    structure: this.accessPoint.id,
                    sortBy: this.sort.sortBy,
                    sortDir: this.sort.sortDir
                };
                srr.loadSafetyRecommendations(filters, this.page)
                    .then(data => {
                        this.data = data;
                    })
                    .catch(error => {
                        toastr.error(
                            "Error al cargar las recomendaciones de seguridad"
                        );
                    });
            } else {
                const filters = {
                    ...this.theFilters,
                    client: this.theClient.id,
                    sortBy: this.sort.sortBy,
                    sortDir: this.sort.sortDir
                };
                srr.loadSafetyRecommendations(filters, this.page)
                    .then(data => {
                        this.data = data;
                    })
                    .catch(error => {
                        toastr.error(
                            "Error al cargar las recomendaciones de seguridad"
                        );
                    });
            }
        },
        changePage(page) {
            this.page = page;
            this.loadSafetyRecommendations();
        },
        loadAccessPoints() {
            const sr = { ...structuresRepository };
            sr.accessPointsByClient(
                !!this.theClient ? this.theClient.id : this.client.id
            )
                .then(data => (this.accessPoints = data))
                .catch(error =>
                    toastr.error(
                        "Error al cargar los puntos de acceso en recomendaciones de seguridad"
                    )
                );
        },
        loadAuthorsRecommendations() {
            const srr = { ...safetyRecommendationsRepository };
            srr.loadSafetyRecommendationsAuthors()
                .then(data => (this.authors = data))
                .catch(error =>
                    toastr.error("Ocurrió un error al cargar los autores")
                );
        },
        startSave() {
            this.selectRecommendation = "";
            this.$bus.$emit("safety-recommendation-form.open");
        },
        startUpdate(recommendation) {
            this.selectRecommendation = Object.assign({}, recommendation);
            this.$bus.$emit("safety-recommendation-form.open");
        },
        startRemove(recommendation) {
            this.selectRecommendation = recommendation;
            this.$bus.$emit("safety-recommendation-remove.open");
        },
        startUploadPhotos(recommendation) {
            this.selectRecommendation = recommendation;
            this.$bus.$emit("upload-photos-recommendation.open");
        },
        cleanForm() {
            this.$bus.$emit("safety-recommendation-form.clean");
        },
        onSave() {
            this.$bus.$emit("safety-recommendation-form.close");
            this.loadSafetyRecommendations();
        },
        deleteRecommendation(recommendation) {
            const srr = { ...safetyRecommendationsRepository };
            srr.deleteSafetyRecommendation(recommendation.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadSafetyRecommendations();
                        this.$bus.$emit("safety-recommendation-remove.close");
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error(
                        "No se pudo borrar la recomendación de seguridad"
                    );
                });
        },
        savePhotos() {
            const formData = new FormData();

            formData.append("recommendationId", this.selectRecommendation.id);
            if (this.isSupervision) {
                formData.append("userId", this.$store.getters.supervisor.id);
            } else {
                formData.append("userId", this.user.id);
            }

            if (this.files.photos) {
                this.files.photos.map(item =>
                    formData.append("photos[]", item)
                );
            }
            if (this.files.files) {
                this.files.files.map((item, index) =>
                    formData.append("file" + index, item)
                );
            }

            const srr = { ...safetyRecommendationsRepository };
            srr.saveSafetyRecommendationPhotos(formData)
                .then(data => {
                    if (data.status) {
                        this.loadSafetyRecommendations();
                        toastr.success(data.msg);
                        this.$bus.$emit("upload-photos-recommendation.close");
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error(
                        "Error al guardar las fotos de la recomendación de seguridad"
                    );
                });
        },
        cancelFilesSelected() {
            this.$bus.$emit("upload-safety-recommendation-photos.clean");
            this.files = "";
            toastr.success("Archivos cancelados");
        },
        onFilter(filters) {
            this.theFilters = filters;
            this.loadSafetyRecommendations();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadSafetyRecommendations();
        },
        initialize() {
            this.loadAccessPoints();
            this.loadSafetyRecommendations();
            this.loadAuthorsRecommendations();
        }
    },
    created() {
        this.clientRequired = !this.user.profile.client_required ? true : false;
        this.initialize();
    }
};
</script>
